/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, get, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';
import { filterId as accessPointFilterId } from '../access-point-filter/AccessPointFilter';
import { filterId as wlcFilterId } from '../wireless-controller-filter/WirelessControllerFilter';

export const filterId = 'Device';
export const filterTitle = t`Device`;
export const entityType = ENTITY_TYPES.DEVICE;

export function useNetworkDevice() {
    return useEntity(filterId);
}

export function useNetworkDeviceName() {
    return useEntityName(filterId);
}

const columns = [
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: 'IP Address',
        width: 150,
        flex: 1,
        sortable: true,
        mapping: 'ipAddress',
    },
];

const dataSourceParams = {
    entityFields: ['name', 'ipAddress'],
};

function NetworkDeviceFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

NetworkDeviceFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

NetworkDeviceFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: (device) => {
                const deviceType = get(device, 'deviceType');
                let deviceTypeTarget;
                let deviceTypeFilterId;
                switch (deviceType) {
                    case 'accesspoint':
                        deviceTypeTarget = '/access-point-detail';
                        deviceTypeFilterId = accessPointFilterId;
                        break;
                    case 'wirelesscontroller':
                        deviceTypeTarget = '/wireless-controller-detail';
                        deviceTypeFilterId = wlcFilterId;
                        break;
                    default:
                        deviceTypeTarget = '/device-detail';
                        deviceTypeFilterId = filterId;
                }
                return defaultsDeep(
                    {
                        target: deviceTypeTarget,
                        mappedFilterParams: {
                            [deviceTypeFilterId]: identity,
                        },
                    },
                    EntityListFilter.defaultProps.options.link
                );
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(NetworkDeviceFilter);
